import { PdfExportService } from '../../../../services/export-pdf/pdf-export.service';
import { UserService } from '../../../../services/user.service';
var BestPerformingExposureComponent = /** @class */ (function () {
    function BestPerformingExposureComponent(pdfService, userService) {
        this.pdfService = pdfService;
        this.userService = userService;
        this.bestPerformingExposures = [];
        this.showIndexNumber = false;
        this.forPayingUser = false;
    }
    BestPerformingExposureComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.bestPerformingExposures.length === 0) {
            this.pdfService.incrementNumberReportReady(BestPerformingExposureComponent.COMPONENT_NAME);
        }
        this.pdfService.imagedLoadedTrigger.subscribe(function (data) {
            if (data.component === BestPerformingExposureComponent.COMPONENT_NAME
                && data.currentCounter === _this.bestPerformingExposures.length) {
                console.log("bestPerformingExposures image counter: " + data.currentCounter);
                _this.pdfService.incrementNumberReportReady(BestPerformingExposureComponent.COMPONENT_NAME);
            }
        });
    };
    Object.defineProperty(BestPerformingExposureComponent.prototype, "showFallbackView", {
        get: function () {
            return this.bestPerformingExposures.length === 0
                || (this.forPayingUser && this.userService.isFreeUser() && !this.userService.isAdmin);
        },
        enumerable: true,
        configurable: true
    });
    BestPerformingExposureComponent.COMPONENT_NAME = 'BestPerformingExposureComponent';
    return BestPerformingExposureComponent;
}());
export { BestPerformingExposureComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/best-performing-exposure/best-performing-exposure.component.ts.pre-build-optimizer.js